// Header Bar Donate Button
$('.header-top-bar .btn-donate').off('click');
$('.header-top-bar .btn-donate').on('click', function() {
  // Track event
  trackEvent('donate_button', 'click', 'donate', 'header_bar_donate_button_click' );
});

// Footer Donate Button
$('.footer-container .btn-donate').off('click');
$('.footer-container .btn-donate').on('click', function() {
  // Track event
  trackEvent('donate_button', 'click', 'donate', 'footer_donate_button_click' );
});

// Header Tagline Donate Button
$('.header-tagline-container .btn-donate').off('click');
$('.header-tagline-container .btn-donate').on('click', function() {
  // Track event
  trackEvent('donate_button', 'click', 'donate', 'mobile_header_tagline_donate_button_click' );
});

// Mobile Menu Donate Button
$('.mobile-header-main-menu .mobile-menu-donate a').off('click');
$('.mobile-header-main-menu .mobile-menu-donate a').on('click', function() {
  // Track event
  trackEvent('donate_button', 'click', 'donate', 'mobile_menu_donate_button_click' );
});

// Footer "Keep Up With Us" image/link
$('#footer-keep-up-link').on('click', function() {
  // Track event
  trackEvent('subscribe_click', 'click', 'subscribe', 'footer_subscribe_click' );
});

// Footer Amazon Smile image/link
$('#amznCharityBanner a').on('click', function() {
  // Track event
  trackEvent('amazon_smile_click', 'click', 'amazon_smile', 'footer_amazon_smile_click' );
});

// Social links
$('.social-links li a').on('click', function() {
  // Track event
  trackEvent('social', 'click', 'social', $(this).attr('href') );
});

// Click to call
$('a[href^="tel:"]').on('click', function(e) {
  // Track event
  trackEvent('click_to_call', 'click_to_call', 'call', 'click_to_call_' + $(this).text().replace(/-/g, '_') );
});

// Mobile Menu Click to call
$('.mobile-header-main-menu a[href^="tel:"]').off('click');
$('.mobile-header-main-menu a[href^="tel:"]').on('click', function(e) {
  // Track event
  trackEvent('click_to_call', 'click_to_call', 'call', 'mobile_menu_click_to_call_' + $(this).text().replace(/-/g, '_') );
});

// Event Sidebar Volunteer button(s)
$('.cpatch-widget-event-details .btn-gray').off('click');
$('.cpatch-widget-event-details .btn-gray').on('click', function() {
  var btnText = $(this).text().toLowerCase().replace(/ /g, '_');
  // Track event
  trackEvent('event_action', 'click', 'event_' + $('body').find('h1:first').text().trim().replace(/ /g, '_'), 'event_button_click_' + btnText );
});

// Gravity Forms Submit
$(document).bind('gform_confirmation_loaded', function(event, formId){
    // Code to be trigger when confirmation page is loaded
    if ( formId == 4 ) {
      // Contact Form
      trackEvent('form_submit', 'submit', 'contact_us', 'contact_us_form_submit' );
    } else if ( formId == 6 ) {
      // Auction RSVP
      trackEvent('form_submit', 'submit', 'auction_rsvp', 'auction_rsvp_form_submit' );
    } else if ( formId == 16 ) {
      // Auction RSVP
      trackEvent('form_submit', 'submit', 'raffle_tickets_purchase', 'raffle_tickets_form_submit' );
    } else if ( formId == 3 ) {
      // Donation Form
      trackEvent('form_submit', 'submit', 'donation', 'donation_form_submit' );

      if ( THEPATCH_GA_CODE.length ) {
        // Simulate page view for confirmation
        gtag('config', THEPATCH_GA_CODE, {
          'page_title' : 'Donation Confirmation',
          'page_path': '/donate/success/'
        });
      }

    } else if ( formId == 9 ) {
      // Golf Team Full Sponsor
      trackEvent('form_submit', 'submit', 'golf_team_full_sponsor', 'golf_team_full_sponsor_form_submit' );
    } else if ( formId == 8 ) {
      // Golf Team Half Sponsor
      trackEvent('form_submit', 'submit', 'golf_team_half_sponsor', 'golf_team_half_sponsor_form_submit' );
    } else if ( formId == 5 ) {
      // Golf Team Individual Sponsor
      trackEvent('form_submit', 'submit', 'golf_team_individual_sponsor', 'golf_team_individual_sponsor_form_submit' );
    } else if ( formId == 12 ) {
      // Putt for the Patch -- Gallery Pass
      trackEvent('form_submit', 'submit', 'mix_mingle_gallery_pass', 'mix_mingle_gallery_pass_form_submit' );
    } else if ( formId == 10 ) {
      // Putt for the Patch
      trackEvent('form_submit', 'submit', 'putt_for_the_patch', 'putt_for_the_patch_form_submit' );
    }
});